import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class DocumentDownloadRequest implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Media';
  readonly apiRoute: string = CONFIG.apiRoutes.documentDownload;

  mediaItemDetailsId: string;

  json() {
    return this;
  }

  loadFromJson(data) {
    this.mediaItemDetailsId = data.mediaItemDetailsId;
  }
}
